import { useState, useEffect } from 'react'

/*
  Atrasa a propagação de um valor que muda a cada tecla — o texto de um campo de busca — para
  que a tela só refaça a consulta quando a digitação parar.

  Uso:

    const [customerName, setCustomerName] = useState('')
    const debouncedCustomerName = useDebouncedValue(customerName, 500)

    useEffect(() => { getData() }, [debouncedCustomerName])

  O atraso é do valor, e não da requisição, de propósito. Envolver a chamada num setTimeout (o
  padrão de PromoCodes) cobra a espera também na abertura da tela, quando ninguém digitou nada e
  não há o que economizar. Aqui o estado nasce com o valor recebido: o efeito de quem usa o hook
  roda na montagem com o valor certo e busca na hora, e o relógio que a montagem arma entrega o
  mesmo valor que já está lá, então o React descarta o setState sem renderizar de novo.
*/
export default function useDebouncedValue(value, delay = 500) {
  const [debouncedValue, setDebouncedValue] = useState(value)

  useEffect(() => {
    const timeout = setTimeout(() => setDebouncedValue(value), delay)

    return () => clearTimeout(timeout)
  }, [value, delay])

  return debouncedValue
}
